import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allHeardAboutUsSources: null,
  },
  getters: {
    getAllHeardAboutUsSources: (state) => {
      if (state.allHeardAboutUsSources) {
        return state.allHeardAboutUsSources;
      }
    },
  },
  mutations: {
    setAllHeardAboutUsSources(state, data) {
      state.allHeardAboutUsSources = data;
    },
  },
  actions: {
    enquirySubmit({ commit, dispatch, getters }, enquiry) {
      return new Promise((resolve, reject) => {
        // set the cj event id
        enquiry.cJEvent = $cookies.get('cje');
        axios.post('/core/enquiries/enquire', enquiry).then((res) => {
          // fetch current logged in user
          dispatch('users/fetchLoggedInUser', { forceReload: true }, { root: true });
          resolve(res.data);
        }).catch((err) => { reject(err); });
      });
    },
  },

};
